<!--凭证详情-->
<template>
  <section>
    <div class="personal-center-form__section">
      <h1 class="personal-center-form__title repayment_h1">凭证详情
        <span class="ask-time">申请时间　{{applyDate}}</span>
      </h1>
      <div class="repayment-top"
           style="background: #fff; padding: 15px;"
           id="frontVoucherInfoBox">

        <!--start-->
        <el-form class="financing-dialog-form-body"
                 ref="step3list"
                 label-width="150px">
          <el-form-item label="买方"
                        inline-message="true">
            <el-input v-model="infoData.buyerName"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="类型"
                        inline-message="true">
            <el-input v-model="typeStr"
            class="input-change"
                      :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="状态"
                        prop="stateName"
                        inline-message="true">
            <el-input v-model="infoData.stateName"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="开票日期"
                        v-if="infoData.type!=7"
                        inline-message="true">
            <el-date-picker v-model="infoData.accountsReceivableStartTime"
                            type="date"
                            :disabled="isDisabled"
                            value-format="yyyy-MM-dd"
                            placeholder="">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="汇票到期日"
                        v-if="showRule.includes('accountsReceivableEndTime')"
                        inline-message="true">
            <el-date-picker v-model="infoData.accountsReceivableEndTime"
                            type="date"
                            :disabled="isDisabled"
                            value-format="yyyy-MM-dd"
                            placeholder="">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发票代码"
                        v-if="infoData.type==4"
                        inline-message="true">
            <el-input v-model="infoData.invoiceCode"
                      class="input-change"
                      :disabled="isDisabled"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="发票校验码"
                        v-if="infoData.type==4"
                        inline-message="true">
            <el-input v-model="infoData.checkCode"
                      class="input-change"
                      :disabled="isDisabled"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item :label="bizNoName"
                        inline-message="true">
            <el-input v-model="infoData.bizNo"
                       v-if="infoData.type!=7"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item :label="receivableAmountName"
                         v-if="infoData.type!=7"
                        inline-message="true">
            <el-input v-model="infoData.accountsReceivableAmount"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>

          <el-form-item label="合同编号"
                        v-if="showRule.includes('contractNumber')"
                        inline-message="true">
            <el-input v-model="infoData.contractNumber"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="合同名称"
                        v-if="showRule.includes('contractName')"
                        inline-message="true">
            <el-input v-model="infoData.contractName"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="订单号"
                        v-if="showRule.includes('orderNo')"
                        inline-message="true">
            <el-input v-model="orderData.orderNo"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="送货单号"
                        v-if="showRule.includes('deliveryNo')"
                        inline-message="true">
            <el-input v-model="orderData.deliveryNo"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="收货单号"
                        v-if="showRule.includes('receiptNo')"
                        inline-message="true">
            <el-input v-model="orderData.receiptNo"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>

          <el-form-item label="品名"
                        v-if="showRule.includes('goodsName')"
                        inline-message="true">
            <el-input v-model="orderData.goodsName"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="规格"
                        v-if="showRule.includes('spec')"
                        inline-message="true">
            <el-input v-model="orderData.spec"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="单位"
                        v-if="showRule.includes('unit')"
                        inline-message="true">
            <el-input v-model="orderData.unit"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="单价"
                        v-if="showRule.includes('unitPrice')"
                        inline-message="true">
            <el-input v-model="orderData.unitPrice"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="数量"
                        v-if="showRule.includes('num')"
                        inline-message="true">
            <el-input v-model="orderData.num"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="总价"
                        v-if="showRule.includes('totalPrice')"
                        inline-message="true">
            <el-input v-model="orderData.totalPrice"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>

          <el-form-item label="出票人全称"
                        v-if="showRule.includes('drawer')"
                        inline-message="true">
            <el-input v-model="billData.drawer"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="承兑人全称"
                        v-if="showRule.includes('acceptor')"
                        inline-message="true">
            <el-input v-model="billData.acceptor"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="承兑人开户行"
                        v-if="showRule.includes('acceptorBank')"
                        inline-message="true">
            <el-input v-model="billData.acceptorBank"
                      :disabled="isDisabled"
                      class="input-change"
                      placeholder=""></el-input>
          </el-form-item>
          <el-form-item>
            <el-input style="opacity: 0;"></el-input>
          </el-form-item>

        </el-form>
        <!--end-->

        <ul class="file-list__item-list">
          <template v-for="file in sysFileIds">
            <li v-if="/\.pdf|\.doc|\.docx|\.xls|\.xlsx|\.rar|\.zip|\.7z/g.test(file.fileName)"
                :class="['file-list__item-preview', `file-list__${file.fileName.substr(file.fileName.lastIndexOf('.')+1)}-preview`]"
                @click.self="showPreviewImage(file.fileId, false)">

              <div class="file-list__file-name">{{file.fileName}}</div>
            </li>
            <li v-else
                class="file-list__item-preview">
              <img :src="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${file.fileId}&tokenId=${tokenId}`"
                   @click="showPreviewImage(file.fileId, true)">
            </li>
          </template>
        </ul>
      </div>

      <el-dialog class="file-preview-modal"
                 title="图片预览"
                 :visible="filePreview.show"
                 :before-close="hidePreviewImage"
                 :close-on-click-modal="false">
        <div class="file-preview-modal__body">
          <img :src="filePreview.src"
               alt="图片预览">
        </div>
        <div slot="footer"
             class="dialog__footer">
          <button class="dialog__footer__confirm-btn"
                  @click="hidePreviewImage">确定</button>
        </div>
      </el-dialog>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from '../../vuex/types/type';
import RepaymentList from './RepaymentList.vue';
import loanApi from '../../api/personalCenter/myloan_bl';
import api from '../../api/personalCenter/myBill.js';
export default {
  components: {
    RepaymentList
  },
  data () {
    return {
      filePreview: {
        show: false,
        src: ''
      },
      tokenId: localStorage.getItem('dl_tokenId_bl'),
      sysFileIds: [],
      isDisabled: true,
      infoData: {},
      billData: {},
      orderData: {},
      typeList: [],
      applyDate:
        `${new Date().getFullYear()
        }-${
        new Date().getMonth() + 1
        }-${
        new Date().getDate()}` // 申请时间
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.GET_USER,
      ajaxBaseUrl: types.GET_AJAX_BASE_URL
    }),
    // 类型名字
    typeStr () {
      const infoData = this.infoData;
      const typeList = this.typeList;
      if (!infoData.type || !typeList) {
        return '';
      }
      return typeList.filter(item => item.value === infoData.type)[0].label;
    },
    // 字段显示规则
    showRule () {
      const type = this.infoData.type;
      if (['5', '6'].includes(type)) {
        // 账单类
        return [
          'accountsReceivableEndTime',
          'drawer',
          'acceptor',
          'acceptorBank'
        ];
      } else if (['1', '2', '3', '4'].includes(type)) {
        // 订单类
        const base = [
          'contractNumber',
          'contractName',
          'goodsName',
          'spec',
          'unit',
          'unitPrice',
          'num',
          'totalPrice'
        ];
        const rule = {
          1: [...base],
          2: [...base, 'orderNo'],
          3: [...base, 'receiptNo'],
          4: [...base, 'orderNo', 'deliveryNo']
        };
        return rule[type];
      } else {
        return [];
      }
    },
    bizNoName () {
      const type = this.infoData.type;
      const obj = {
        '1': '订单号',
        '2': '送货/入库单号',
        '3': '结算单号',
        '4': '发票号码',
        '5': '票据号码',
        '6': '票据号码'
      };
      return obj[type];
    },
    receivableAmountName () {
      const type = this.infoData.type;
      const map = {
        '1': '订单总额',
        '2': '送货单金额',
        '3': '结算单金额',
        '4': '发票金额',
        '5': '票面金额',
        '6': '票面金额'
      };
      return map[type];
    }
  },
  methods: {
    getInfo () {
      loanApi
        .getFrontVoucherInfoDetails({
          // 详情
          frontApplyId: this.$route.params.frontApplyId,
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          voucherInfoId: this.$route.params.voucherInfoId
        })
        .then((res) => {
          if (res.rspcode == 1) {
            this.infoData = res.data.voucherInfo;
            const type = res.data.voucherInfo.type;
            this.infoData.receivableAmount =
              res.data.voucherInfo.accountsReceivableAmount;
            this.sysFileIds = res.data.voucherInfo.sysFileIds
              ? JSON.parse(res.data.voucherInfo.sysFileIds.replace(/\'/g, '"'))
              : [];
            if (res.data.applyDate) {
              this.applyDate = res.data.applyDate;
            }
            if (['1', '2', '3', '4'].includes(type)) {
              // 订单类(1:订单 2送货单/入库单 3结算单 4发票)
              // 获取订单类型数据
              this.orderData = res.data.order;
            } else if (['5', '6'].includes(type)) {
              // 账单类(5:银承 6商承 )
              // 获取账单类型数据
              this.billData = res.data.bill;
            }

            if (res.data.voucherInfo.accountsReceivableEndTime) {
              this.infoData.accountsReceivableEndTime = this.formTime(
                res.data.voucherInfo.accountsReceivableEndTime
              );
            }
          }
        })
        .catch((error) => {});
    },
    formTime (value) {
      const time = new Date(value);
      const year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let h = time.getHours();
      let mm = time.getMinutes();
      if (month <= 9) {
        month = `0${month}`;
      }
      if (day <= 9) {
        day = `0${day}`;
      }
      if (h <= 9) {
        h = `0${h}`;
      }
      if (mm <= 9) {
        mm = `0${mm}`;
      }
      return `${year}-${month}-${day}`;
    },
    showPreviewImage (fileId, isImage) {
      const src = `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${fileId}&tokenId=${this.userInfo.token}`;
      if (isImage) {
        this.filePreview = {
          show: true,
          src
        };
      } else {
        window.open(`${location.origin}${src}`);
      }
    },

    hidePreviewImage () {
      this.filePreview.show = false;
    },
    getDic () {
      api.getByNodeKeyPC({ NodeKeys: 'voucher_type' }).then((res) => {
        this.typeList = res[0];
      });
    }
  },
  mounted () {
    this.getInfo();
    this.getDic();
  }
};
</script>
<style lang="scss">
#frontVoucherInfoBox .el-input {
  width: 115%;
}
#frontVoucherInfoBox .el-form-item__label {
  color: #ff8b38;
}
.ask-time {
  float: right;
  margin-top: 6px;
  font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
  font-size: 10px;
  font-weight: normal;
  color: $lightSilver;
}

.repayment-top {
  overflow: hidden;
  background: #f5f7f8;
}

.should-repaymen {
  float: left;
  overflow: hidden;
  padding-top: 30px;
  border-radius: 7px;
  width: 417px;
  height: 126px;
  background: $white;

  dt {
    font-size: 18px;
    color: $orange;
    line-height: 34px;
    font-family: "FZLanTingHei_GBK";
  }

  dt:after {
    content: "Repayment amount";
    display: block;
    color: #3e454d;
    font-size: 13px;
    line-height: 15px;
    font-family: "MyriadPro-Regular";
  }

  dd {
    font-size: 30px;
    color: #59402e;
    line-height: 44px;
    font-family: "MyriadPro-Bold";
  }
}

.repay-details {
  float: right;
  border-radius: 7px;
  padding: 13px;
  width: 409px;
  height: 130px;
  background: $white;

  li {
    width: 183px;
    padding-left: 20px;
    height: 64px;
    float: left;
    span {
      display: block;
      height: 26px;
      color: $lightSilver;
      font-size: 12px;
      line-height: 28px;
    }
    strong {
      display: block;
      height: 30px;
      color: $personalCenterTitleBlack;
      font-size: 20px;
      line-height: 28px;
      font-family: "MyriadPro-Bold";
    }
  }
  li:first-child {
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
  }
  li:nth-child(2) {
    border-bottom: 1px solid #eee;
  }
  li:nth-child(3) {
    border-right: 1px solid #eee;
  }
  li:last-child strong {
    color: $personalCenterFormLabel;
  }
}

.repayment-tips {
  overflow: hidden;
  margin: 27px 0;
  width: 100%;
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  text-indent: 30px;
  background: #e6e9ea url("../../../static/images/icons/failed_alert_icon.png")
    no-repeat 8px center;
  background-size: 16px;
  font-family: "FZLanTingHei_GBK";
}
.input-change{
  width: 131% !important;
}
</style>



// WEBPACK FOOTER //
// FrontVoucherInfo_bl.vue?6c649de1